import {useTitle as reactUseUseTitle} from 'react-use';

/** @see {@link https://en.wikipedia.org/wiki/Middot} */
const interpunct = '\u00B7';

export default function useTitle(title: string) {
	reactUseUseTitle(`${title} ${interpunct} Vent Creativity`);
}
